import React from 'react';
import { useTranslation } from 'react-i18next';
import StoreSwitcher from './StoreSwitcher';
import NotificationsDropdown from './NotificationsDropdown';
import LanguageSwitcher from '../common/LanguageSwitcher';
import './TopNav.css';

const TopNav = ({ user, onToggleSidebar, stores, activeStoreId, activeStore, onStoreChange }) => {
  const { t } = useTranslation();
  // Appwrite user structure: { $id, name, email, ... }
  // Fallbacks for shop name - try to get from user name or email
  const shopName =
    activeStore?.storeName ||
    user?.shopName ||
    user?.name ||
    user?.email?.split('@')[0] || // Use email prefix as fallback
    "Seller's Shop";
  // Only a photo the seller actually set; otherwise a neutral profile icon
  // (never a stock photo of some other person).
  const avatarSrc = user?.avatarUrl || user?.prefs?.avatarUrl || null;

  return (
    <div className="topnav">
      <div className="navcontainer">
        <button className="hamburger" onClick={onToggleSidebar} aria-label="Toggle Sidebar">
          ☰
        </button>
        <div className="dashboard">{t('nav.dashboard')}</div>
        <div className="profile">
          <div className="icon">
            <div className="paulosShopParent">
              {stores && stores.length > 0 ? (
                <StoreSwitcher
                  stores={stores}
                  activeStoreId={activeStoreId}
                  onStoreChange={onStoreChange}
                />
              ) : (
              <div className="paulosShop">{shopName}</div>
              )}
            </div>
          </div>
          <LanguageSwitcher />
          <NotificationsDropdown />
          {avatarSrc ? (
            <img className="profile1Icon" alt="User Avatar" src={avatarSrc} />
          ) : (
            <span className="profile1Icon profile-placeholder" role="img" aria-label="User profile">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
                   strokeLinecap="round" strokeLinejoin="round" width="18" height="18" aria-hidden="true">
                <circle cx="12" cy="8" r="4" />
                <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
              </svg>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopNav; 